<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ser">
<p class="rv"><a class="page" id="pi"></a>“In this volume Bruce Waltke, James Houston, and Erika Moore cover a selection of psalms that strikingly combine sadness and sorrow with faith and hope. . . . Masterful exegesis here blends with luminous theological perspectives and pastoral insights.”</p>
<p class="rvt">— J<span class="sm">.</span> I<span class="sm">.</span> P<span class="sm">ACKER</span></p>
<p class="rvt"><i>Regent College</i></p>
<p class="rv">“If you plan to preach on these hymns of hurt and confusion, this book is a good place to begin. Each psalm is translated in a helpful way, which is vital for preaching these psalms well.”</p>
<p class="rvt">— H<span class="sm">ADDON</span> R<span class="sm">OBINSON</span></p>
<p class="rvt"><i>Gordon-Conwell Theological Seminary</i></p>
<p class="rv">“Here is the finest of guides to laments in the book of Psalms. The authors recover a cogent interpretation of personal sin that forms the basis of the need for God’s redemption. The cry of lament begins in the heart of the psalmist — and of his readers — and proceeds to express complete dependence on God. Journey on this ancient path of laments that bring us into God’s presence as no other texts of Scripture do.”</p>
<p class="rvt">— R<span class="sm">ICHARD</span> S<span class="sm">.</span> H<span class="sm">ESS</span></p>
<p class="rvt"><i>Denver Seminary</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-psalmschristian-0002.vue?9f76399a